import React, { useEffect, useState } from 'react';

import styled from '@emotion/styled';

import BarChart from '../../../../components/Charts/BarChart';
import ChartFilter from '../../../../components/Charts/ChartFilter/ChartFilter';
import usePerformanceInsight from '../../../../hooks/dashboard/driver-list/usePerformanceInsight';

const RatingMetrics = ({ baseUrl }: { baseUrl: string }) => {
  const [dataUrl, setDataUrl] = useState<string>(baseUrl);

  const {
    getPerformanceDataInsight,
    // loading,
    PerformanceInsightData,
  } = usePerformanceInsight();

  useEffect(() => {
    if (!dataUrl) return;
    getPerformanceDataInsight(dataUrl);

    // eslint-disable-next-line
  }, [dataUrl]);

  return (
    <Container>
      <HeaderArea>
        <Header>Rating Metrics</Header>

        <ControlArea>
          <ChartFilter setDataUrl={setDataUrl} dataUrl={dataUrl} variant='year' />
        </ControlArea>
      </HeaderArea>

      <Container>
        <BarChart
          xAxisDataKey='month'
          data={PerformanceInsightData}
          isAnimationActive={true}
          dataKeys={['companyCount']}
          fills={['#5B91F5']}
          showLegend={false}
          aspect={3}
          tooltipLabel={['Rating Metrics']}
        />
      </Container>
    </Container>
  );
};

export default RatingMetrics;

const Container = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 24px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
`;

const ControlArea = styled.div`
  display: flex;
`;

const HeaderArea = styled.div`
  font-weight: 600;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  /* border: 1px solid red; */
  margin-bottom: 18px;
`;

const Header = styled.div`
  font-weight: 600;
  font-size: 18px;
`;
